import { render, staticRenderFns } from "./Greenscreen.vue?vue&type=template&id=0e78c1fc&lang=pug&"
import script from "./Greenscreen.vue?vue&type=script&lang=ts&"
export * from "./Greenscreen.vue?vue&type=script&lang=ts&"
import style0 from "./Greenscreen.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports